import { LineChart } from "lucide-react"
import { cn } from "@/lib/utils"

export interface ChartContextChipProps {
  label: string
  className?: string
}

/**
 * Compact chip naming the chart context that went out with a sent message —
 * a record of what the AI was given, not a control. LEGACY: only messages from
 * the "Chart context" tick-box era carry one; workbench changes are now sent on
 * their own by the composer's Send to AI and render as their own card.
 */
export function ChartContextChip({ label, className }: ChartContextChipProps) {
  return (
    <span
      className={cn(
        "ai-capture-chip text-foreground inline-flex items-center gap-1.5 text-caption rounded-md px-2 py-1",
        className,
      )}
    >
      <LineChart size={11} className="shrink-0 text-primary" />
      <span className="truncate max-w-[180px]">{label}</span>
    </span>
  )
}
